import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { useAuthStore } from '../../../stores/auth-store';

const LANDING_KEY = 'chaos-landing-preference';

function ProfilePage() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const [landingPref, setLandingPref] = React.useState<'boards' | 'dashboard'>(() => {
    try {
      return localStorage.getItem(LANDING_KEY) === 'dashboard' ? 'dashboard' : 'boards';
    } catch {
      return 'boards';
    }
  });

  function updateLanding(next: 'boards' | 'dashboard') {
    setLandingPref(next);
    try {
      localStorage.setItem(LANDING_KEY, next);
    } catch {
      /* ignore */
    }
  }

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">{t('settings.profile.title')}</h1>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>{t('settings.profile.title')}</CardTitle>
          <CardDescription>
            Editable profile fields land in Phase 5 (M3 — invitations + membership).
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="profile-name">{t('settings.profile.display_name_label')}</Label>
            <Input id="profile-name" defaultValue={user?.displayName ?? ''} disabled />
          </div>
          <div className="space-y-2">
            <Label htmlFor="profile-email">{t('settings.profile.email_label')}</Label>
            <Input id="profile-email" defaultValue={user?.email ?? ''} disabled />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Landing page</CardTitle>
          <CardDescription>Choose what loads when you sign in (this device only).</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <label className="flex cursor-pointer items-center gap-2 text-sm">
            <input
              type="radio"
              name="landing-pref"
              value="boards"
              checked={landingPref === 'boards'}
              onChange={() => updateLanding('boards')}
              className="accent-foreground"
            />
            Latest board (default)
          </label>
          <label className="flex cursor-pointer items-center gap-2 text-sm">
            <input
              type="radio"
              name="landing-pref"
              value="dashboard"
              checked={landingPref === 'dashboard'}
              onChange={() => updateLanding('dashboard')}
              className="accent-foreground"
            />
            Founder dashboard
          </label>
        </CardContent>
      </Card>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/settings/profile')({
  component: ProfilePage,
});
